import { Box, Chip } from '@mui/material';

const chipStyles = { borderColor: 'devblue.30', fontWeight: 'medium' } as const;

interface MultiselectAnswerProps {
    answer: string[];
}

const MultiselectAnswer: React.FC<MultiselectAnswerProps> = ({ answer }) => (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.25 }}>
        {answer.map((option, optionIndex) => (
            <Chip key={optionIndex} label={option} size="small" variant="outlined" sx={chipStyles} />
        ))}
    </Box>
);

export default MultiselectAnswer;
